jQuery(document).ready(function ($) {
  /**
   * Init emergence library
   */
  emergence.init({
    reset: false,
    elemCusion: 0.95,
  })

  /**
   * Add class to navbar-toggler when clicked
   */
  $('.navbar-toggler').click(function () {
    $(this).toggleClass('open')
    $('.main-navigation').toggleClass('closed')
    $('.main-navigation').toggleClass('open')
    $('body').toggleClass('locked')
  })

  $('.mobile-menu .dropdown-toggle').on('click', function (event) {
    event.preventDefault()
    $(this).toggleClass('active-click')
    $(this).next('.dropdown-menu').toggleClass('d-block')
    var expanded = $(this).attr('aria-expanded')
    if (expanded == 'true') {
      $(this).attr('aria-expanded', 'false')
    } else {
      $(this).attr('aria-expanded', 'true')
    }
  })

  $('.nav-item.dropdown')
    .on('mouseenter', function () {
      $(this).find('.nav-link').attr('aria-expanded', 'true')
    })
    .on('mouseleave', function () {
      $(this).find('.nav-link').attr('aria-expanded', 'false')
    })

  /**
   * Remove mobile menu animation class
   */
  function remove_mobile_menu() {
    var nav_selector = $('.site-header .navbar')
    var responsive_breakpoint = ''

    if (nav_selector.hasClass('navbar-expand-lg')) {
      responsive_breakpoint = 992
    } else if (nav_selector.hasClass('navbar-expand-md')) {
      responsive_breakpoint = 768
    } else if (nav_selector.hasClass('navbar-expand-sm')) {
      responsive_breakpoint = 576
    }

    if ($(window).width() >= responsive_breakpoint) {
      if ($('.main-navigation').hasClass('open')) {
        $('.navbar-toggler').toggleClass('open')
        $('.main-navigation').toggleClass('closed')
        $('.main-navigation').toggleClass('open')
        $('body').toggleClass('locked')
      }
    }
  }

  // Run function on window resize, if window size matches - remove class
  // See above
  $(window).resize(function () {
    remove_mobile_menu()
  })

  /**
   * Set cookie for site notification dismissal
   */
  if ($.cookie('site_note_close') != 'true') {
    $('.site-notification').removeClass('d-none')

    $('.site-note-close').click(function () {
      $.cookie('site_note_close', 'true', { expires: 10, path: '/' })
    })
  } else if ($.cookie('site_note_close') === 'true') {
  }

  /**
   * Testimonial Slider
   */
  $('.testimonial-slider').slick({
    dots: true,
    arrows: false,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  })
  /**
   * Page Section Slider
   */
  $('.page-section-slider').slick({
    dots: false,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow:
      '<button type="button" class="arrow page-section-previous" title="Previous"><i class="far fa-chevron-left"></i></button>',
    nextArrow:
      '<button type="button" class="arrow page-section-next" title="Next"><i class="far fa-chevron-right"></i></button>',
    responsive: [
      {
        breakpoint: 1799,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 829,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },
    ],
  })
  /**
   * Logo Slider
   */
  $('.logo-slider').slick({
    dots: true,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow:
      '<button type="button" class="arrow page-section-previous dark" title="Previous"><i class="far fa-chevron-left"></i></button>',
    nextArrow:
      '<button type="button" class="arrow page-section-next dark" title="Next"><i class="far fa-chevron-right"></i></button>',
  })

  /**
   * Smooth Scroll Hashed Links
   * This will scroll to link on same page
   * Or will smoothly scroll to a hashed section on another page after click
   */

  $(function () {
    // your current click function
    // select all links with hashes, remove if don't link to anything (:not)
    // this is for same page hashed links
    $('a[href*=\\#]:not([href=\\#])').on('click', function () {
      if (!$(this).parents('ul').hasClass('nav-tabs') && !$(this).parents('div').hasClass('tabs__nav')) {
        var target = $(this.hash)
        // if target.length is 0, set target equal to the name attribuite with hash as value
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']')
        // smooth scroll to the target id
        console.log('smooth scrolling')
        if (target.length) {
          $('html,body').animate(
            {
              scrollTop: target.offset().top,
            },
            1000
          )
          return false
        }
      }
    })

    // check if the window location (URL) has a hash in it
    // smoothly scroll to that location
    if (window.location.hash) {
      var target = $(window.location.hash)
      // if target.length is 0, set target equal to the name attribuite with hash as value
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']')
      // smooth scroll to the target id
      $('html, body')
        .delay(1000)
        .animate(
          {
            scrollTop: $(target).offset().top + 'px',
          },
          1000
        )
      return false
    }
  })

  /**
   * Reveal job application form section when button is clicked
   */
  $('.career-form-reveal').click(function () {
    $('.career-form-container').toggleClass('d-none')
  })
})
